export default __webpack_public_path__ + "static/website-preview1-7d6718ed8ab29498eb4b53577a1d2352.png";